import { render, staticRenderFns } from "./cpt-chart-pie-option.vue?vue&type=template&id=4a498ccf&scoped=true"
import script from "./cpt-chart-pie-option.vue?vue&type=script&lang=js"
export * from "./cpt-chart-pie-option.vue?vue&type=script&lang=js"
import style0 from "./cpt-chart-pie-option.vue?vue&type=style&index=0&id=4a498ccf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a498ccf",
  null
  
)

export default component.exports